import { STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_BEGIN } from "../constants"

export function getStateMachine({ statusId }){
    return (dispatch) =>{
        dispatch({
            type: STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_BEGIN,
            data: { statusId }
        })
    }
}